import { clsx } from 'clsx';

import { LinkWithPrevLocation } from '@/components/shared/LinkWithPrevLocation/LinkWithPrevLocation.tsx';
import { appRoutes } from '@/routes/app-routes.ts';
import { useAuthStore, useModalStore } from '@/store';

import { MenuItem } from '../constants.tsx';
import cn from './styles.module.scss';

interface IMenuItemList {
    itemsList: MenuItem[];
    title: string;
    direction?: 'column' | 'row';
    onClick?: () => void;
}

export const MenuItemsList = ({
    itemsList,
    title,
    direction = 'column',
    onClick,
}: IMenuItemList) => {
    const { isAuth } = useAuthStore();
    const { setIsOpen, setShowSignUp } = useModalStore();

    const handleClick = () => {
        setShowSignUp(true);
        setIsOpen(true);
    };

    return (
        <div className={cn.itemsListContainer}>
            <p className={cn.listTitle}>{title}</p>
            <div className={clsx(cn.itemsList, direction)}>
                {itemsList.map(item =>
                    item.path || item.path === '/' ? (
                        !isAuth &&
                        (item.path === appRoutes.myNumbers ||
                            item.path === appRoutes.myReservations) ? (
                            <div
                                onClick={handleClick}
                                key={item.name || item.className}
                                className={cn.listItem}
                            >
                                <span className={cn.iconWrapper}>{item.icon}</span>
                                <span className={cn.itemName}>{item.name}</span>
                            </div>
                        ) : (
                            <LinkWithPrevLocation
                                onClick={onClick}
                                to={item.path}
                                key={item.name || item.className}
                                className={cn.listItem}
                            >
                                <span className={cn.iconWrapper}>{item.icon}</span>
                                <span className={cn.itemName}>{item.name}</span>
                            </LinkWithPrevLocation>
                        )
                    ) : (
                        <a
                            onClick={onClick}
                            key={item.name || item.className}
                            className={cn.listItem}
                        >
                            <span className={cn.iconWrapper}>{item.icon}</span>
                            <span className={cn.itemName}>{item.name}</span>
                        </a>
                    )
                )}
            </div>
        </div>
    );
};
